/// <reference types="@types/grecaptcha" />
import { useCallback, useEffect } from 'react';

export function useRecaptcha(key: string) {
  // Load recaptcha
  useEffect(() => {
    let recaptcha = document.getElementById(
      'grecaptcha'
    ) as HTMLScriptElement | null;

    let rc = document.querySelector('.grecaptcha-badge') as Element | null;

    if (!recaptcha || !rc) {
      recaptcha?.remove();
      recaptcha = document.createElement('script');
      recaptcha.setAttribute(
        'src',
        `https://www.google.com/recaptcha/api.js?render=${key}`
      );
      recaptcha.async = true;
      recaptcha.id = 'grecaptcha';
      document.body.appendChild(recaptcha);
    }
  }, [key]);
  // Add show class to badge
  useEffect(() => {
    let cancel = false;
    (async () => {
      let rc: Element | null = null;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        rc = document.querySelector('.grecaptcha-badge');
        if (rc || cancel) break;
        else
          await new Promise((resolve) => {
            setTimeout(resolve, 1000);
          });
      }
      if (!cancel) rc?.classList.add('show');
    })();
    return () => {
      document.querySelector('.grecaptcha-badge')?.classList.remove('show');
      cancel = true;
    };
  }, []);

  return useCallback(
    async (action = 'reCaptchaValidate') =>
      await grecaptcha.execute(key, {
        action,
      }),
    [key]
  );
}
